class BaseSearchController extends AbstractController
	@register()
	@inject '$injector',
		'$state'
		'$transitions'
		'$q'
		'$scope'
		'searchItems'
		'AdvancedSearchService'
		'BaseRepository'
		# Used inside functions of setSearchData
		'ConfigurationService'
		'UserInformation'
		'MessageTerminal'

	initialize: ->
		# Overwrite to TRUE if using static items
		@useStaticItems ?= false
		@searchOnInit ?= true

		# For smaller screens to automatically hide side menu
		@isSideMenuHidden = true

		@setSearchData()
		@setRepository()
		@subscribeCRUD()

		if !@useStaticItems && @searchOnInit && @searchData.enabled && _.isEmpty @searchItems.items
			@search()

		if @useStaticItems
			@initializeItems()

		if @searchData.redirectOnEmpty
			# Check for redirection when triggering same-state transition
			#
			# E.g. when clicking on menu item while being in active item:
			# 	This would not trigger search method, nor re-initialization, just state change and we get redirected to empty
			#		state, even through `redirectOnEmpty` is TRUE
			deregister = @$transitions.onBefore({}, (transition) =>
				if transition.from().name == transition.to().name && _.isEmpty(transition.params('to')[@searchData.idField])
					@redirectToFirstItem()

					return false
			)

			selfDeregister = @$transitions.onExit({}, (transition) =>
				if transition.to().name != @$state.$current.name
					deregister()
					selfDeregister()
			)

	initializeItems: ->
		items = @getItems()

		if !_.isEmpty items
			@afterSearch(@getItems(), true, false)
		else
			console.error('No search items provided!')

	getItems: ->
		throw Error('Method getItems for static search is not implemented')

	##
	# Sets up search params with default values.
	# If param value is function then it's return value should evaluate to proper type (string|bool)
	# Inside this function THIS points to BaseSearchController
	##
	setSearchData: ->
		defaultSearchParams =
			repositoryName: null
			enabled: true
			filterEnabled: true
			advanced: {}
			term: ''
			searchHeaderTemplate: '@app/layout/views/app.entity-search-header.view.html'
			itemTemplate: '@app/layout/views/app.entity-search-result.view.html'
			labelTemplate: null
			newButtonSRef: "{id: ''}"
			listSRef: "{id: item.id}"
			pageSize: 50
			searchPage: 1
			attribute: 'name'
			###
			# If disabled then do not show new item creation when no ID provided and redirect to first item
			###
			createEnabled: true
			###
			# When no ID provided redirect to first item
			###
			redirectOnEmpty: null
			isSearching: false
			###
			# Repository to use for searching. Must extend BaseRepository.
			# It's name is passed using {searchParams.repositoryName}
			###
			repository: null
			idField: 'id'
			hasMoreItems: true
			translateItem: false

		@searchData = angular.merge {}, defaultSearchParams, @$state.current.data.searchParams

		for own key, value of @searchData
			if angular.isFunction value
				@searchData[key] = value.call(@)

		@searchData.redirectOnEmpty ?= !@searchData.createEnabled
		@advancedSearchEnabled = !_.isEmpty(@searchData.advanced?.configuration)

		if @advancedSearchEnabled
			@searchData.advanced = angular.copy @searchData.advanced

			@setAdvancedSearch()

	resetAdvancedSearch: ->
		@AdvancedSearchService.reset(@searchData.advanced)

	onAdvancedSearchChange: ->
		@AdvancedSearchService.onChange(@searchData.advanced)

	toggleAdvancedSearch: ->
		if !@advancedSearchEnabled
			return

		@showAdvancedSearch = !@showAdvancedSearch

	setAdvancedSearch: ->
		@searchData.advanced = @AdvancedSearchService.initializeFilters(
			@searchData.advanced,
			(filterKey) => return @getAdvancedSearchValues(filterKey)
		)

	setItem: (item) ->
		item = angular.copy(item)
		index = _.findIndex @searchItems.items, @matchItem.bind(@, item)

		if index != -1
			@searchItems.items[index] = item
		else
			@searchItems.items.unshift item

		@afterSetItem item

	removeItem: (item) ->
		@searchItems.items = _.reject @searchItems.items, @matchItem.bind(@, item)

		@afterRemoveItem item

	matchItem: (newItem, oldItem) ->
		return oldItem[@searchData.idField] == newItem[@searchData.idField]

	afterSetItem: (item) ->
		@goToItem item[@searchData.idField]

	afterRemoveItem: (item, searchMore = true, stateOptions = {}) ->
		if searchMore
			@searchMore()

		if !@searchData.createEnabled
			@redirectToFirstItem()
		else
			@goToItem '', @searchData.idField, stateOptions

	goToItem: (paramValue, param = @searchData.idField, options = {}) ->
		stateParams =
			"#{param}": paramValue

		if !@$state.includes('.', stateParams)
			@$state.go '.', stateParams, options

	subscribeCRUD: ->
		@MessageTerminal.on @$scope, @MessageTerminal.events.CRUD.ADD, (item) => @setItem(item)
		@MessageTerminal.on @$scope, @MessageTerminal.events.CRUD.UPDATE, (item) => @setItem(item)
		@MessageTerminal.on @$scope, @MessageTerminal.events.CRUD.REMOVE, (item) => @removeItem(item)

	setRepository: ->
		if @useStaticItems
			return

		if !angular.isString(@searchData.repositoryName) || !@$injector.has(@searchData.repositoryName)
			@searchData.enabled = false
		else
			@searchData.repository = @$injector.get(@searchData.repositoryName)

	##
	# @param isManualSubmit - Indicates that search was made manually - reset pagination to 0
	#	@param appendResult - If set to false instead of adding found items to existing set it will overwrite
	#		it with found items. If {isManualSubmit} is true, this parameter becomes false
	##
	search: (isManualSubmit = false, appendResult = true) ->
		if (!@searchData.isSearching && @searchData.hasMoreItems) || isManualSubmit
			@searchData.isSearching = true
			@showAdvancedSearch = false

			return @searchData
				.repository
				.findByQuery @getQuery(isManualSubmit)
				.then (response) =>
					@afterSearch response.data, isManualSubmit, appendResult
				.finally =>
					@searchData.isSearching = false
		else
			return @$q.when(false)

	getSearchQuery: ->
		return @searchData.repository.getSearchQuery()

	getQuery: (isManualSubmit = false) ->
		query = @getSearchQuery()

		@applySearchFilter query

		if @advancedSearchEnabled
			@applyAdvancedFilter query

		@applyPagination query, isManualSubmit

		return query

	applyAdvancedFilter: (query) ->
		@AdvancedSearchService.apply(query, @searchData.advanced)

	getAdvancedSearchValues: (filterKey) ->
		return @$q.when(null)

	applyPagination: (query, isManualSubmit = false) ->
		if isManualSubmit
			query.setPagination(0, @searchData.pageSize)
			@searchData.searchPage = 1
		else
			query.setPagination(
				(@searchData.searchPage * @searchData.pageSize) - @searchData.pageSize,
				@searchData.pageSize
			)

	applySearchFilter: (query) ->
		if @searchData.term.length > 0
			criteria = query.criteria @searchData.attribute, 'LIKE', @searchData.term

			if @searchData.attribute != 'id'
				criteria.or 'id', 'LIKE', @searchData.term

	afterSearch: (response, isManualSubmit = false, appendResult = true) ->
		@searchData.isSearching = false
		@searchData.hasMoreItems = !@useStaticItems && response.length >= @searchData.pageSize
		@searchData.searchPage++

		if appendResult && !isManualSubmit
			# After joining existing and new values remove duplicates that can occur when adding new item
			@searchItems.items = _.unique(
				@searchItems.items.concat(response),
				(item) =>
					item[@searchData.idField]
			)
		else
			@searchItems.items = response

		if @searchData.redirectOnEmpty && _.isEmpty(@$state.params[@searchData.idField])
			@redirectToFirstItem()

	##
	# Automatically select first item from list when there is no create button
	# When using custom listSRef and no_create is true this may not work.
	# You should override this method to use proper params
	##
	redirectToFirstItem: ->
		if angular.isDefined(@searchItems.items[0])
			@goToItem @searchItems.items[0][@searchData.idField]
		else
			params = {}

			if @searchData.createEnabled
				params = {newButtonSRef: @searchData.newButtonSRef}

			@$state.go 'empty_state', params

	##
	# Search for more items if there is gap between current items set and max page size
	# E.g. After you deleted item, one more item from other page should be retrieved to current page
	##
	searchMore: ->
		if @searchData.hasMoreItems
			oldSearchPage = @searchData.searchPage
			@searchData.searchPage--
			@searchData.searchPage = 1 if @searchData.searchPage < 1

			@search()
				.then =>
					@searchData.searchPage = oldSearchPage
